import { addRegion } from "../../../../../actions/Utilities/Region";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { addStateRegion } from "../atoms/atoms";
import { useRecoilState } from "recoil";
import useSendEmail from "../../hooks/useSendEmail";

const useAddRegion = () => {
  const queryClient = useQueryClient();
  const [, setActionAddState] = useRecoilState(addStateRegion);
  const { mutateAsync: sendEmail } = useSendEmail();

  const { mutate } = useMutation((regionNewData) => addRegion(regionNewData), {
    onSuccess: (res) => {
      if (res === "Duplicate") {
        toast.fire(
          "Saving Failed",
          "Region Name or Region Code already exists!",
          "warning"
        );
      } else {
        queryClient.invalidateQueries(["GetRegion"]);
        sendEmail(res.data, {
          onSuccess: (res) => {
            if (res) {
              if (res.status === 400) {
                toast.fire(
                  "Success",
                  "Region Added Successfully, but failed in sending email",
                  "warning"
                );
              } else {
                toast.fire("Success", "Region Added Successfully", "success");
              }
            }
          },
        });
        setActionAddState(false);
      }
    },
    onError: () => {
      toast.fire("Failed", "Failed to Add Region!", "error");
    },
  });

  return mutate;
};
export default useAddRegion;
